import React, { FunctionComponent, useContext, useEffect } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { ApplicationLayoutContent } from 'layouts/ApplicationLayout/components';
import { routes } from 'static/routes';
import {
    StartWorkflowPage,
    ChooseMethodPage,
    PhoneNumberCheckPage,
    ConfirmCodePage,
    DocumentLockedPage,
    SessionTimeoutPage,
    PageNotFoundPage,
    GeneralErrorPage,
    EnterPhoneNumberPage,
    SendEmailCodePage,
} from 'components/pagesInk';
import VerifyApplicationContext from 'contexts/VerifyApplicationContext';

const VerifyApplicationContent: FunctionComponent = () => {
    const context = useContext(VerifyApplicationContext);
    const history = useHistory();

    useEffect(() => {
        if (context.isDocumentLocked && window.location.pathname !== routes.DocumentLocked) {
            history.replace(routes.DocumentLocked);
        }
    }, [history, context]);

    return (
        <ApplicationLayoutContent>
            <Switch>
                <Route exact path={[routes.StartWorkflow, routes.Home]}>
                    <StartWorkflowPage />
                </Route>

                <Route exact path={[routes.ChooseMethod]}>
                    <ChooseMethodPage />
                </Route>

                <Route exact path={[routes.EnterPhoneNumber]}>
                    {context.allowRecipientProvidedPhoneNumber ? (
                        <EnterPhoneNumberPage />
                    ) : (
                        <Redirect to={routes.ChooseMethod} />
                    )}
                </Route>

                <Route exact path={[routes.ConfirmCode]}>
                    <ConfirmCodePage />
                </Route>

                <Route exact path={[routes.CheckDigits]}>
                    <PhoneNumberCheckPage />
                </Route>

                <Route exact path={[routes.DocumentLocked]}>
                    <DocumentLockedPage />
                </Route>

                <Route exact path={[routes.SessionExpired]}>
                    <SessionTimeoutPage />
                </Route>

                <Route exact path={[routes.SendEmailCode]}>
                    <SendEmailCodePage />
                </Route>

                <Route exact path={[routes.Error]}>
                    <GeneralErrorPage />
                </Route>

                <Route>
                    <PageNotFoundPage />
                </Route>
            </Switch>
        </ApplicationLayoutContent>
    );
};

export default VerifyApplicationContent;
